import { Minus, Plus } from "lucide-react";

interface QuantityInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
}

export default function QuantityInput({ value, onChange, min = 0 }: QuantityInputProps) {
  return (
    <div>
      <label className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5 block">
        Količina
      </label>
      <div className="flex items-center gap-3 max-w-[200px]">
        <button
          type="button"
          onClick={() => onChange(Math.max(min, value - 1))}
          className="size-12 shrink-0 rounded-xl border-2 border-neutral-200 bg-neutral-50 hover:bg-neutral-100 flex items-center justify-center transition active:scale-95 active:bg-neutral-200"
        >
          <Minus className="size-5 text-neutral-700" strokeWidth={2.5} />
        </button>
        <input
          type="number"
          min={min}
          value={value}
          onChange={(e) => onChange(Math.max(min, parseInt(e.target.value) || 0))}
          className="w-16 h-12 shrink-0 rounded-xl border border-border bg-white text-center text-lg font-bold tabular-nums outline-none focus:ring-2 focus:ring-foreground/10 focus:border-foreground transition [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        />
        <button
          type="button"
          onClick={() => onChange(value + 1)}
          className="size-12 shrink-0 rounded-xl border-2 border-neutral-200 bg-neutral-50 hover:bg-neutral-100 flex items-center justify-center transition active:scale-95 active:bg-neutral-200"
        >
          <Plus className="size-5 text-neutral-700" strokeWidth={2.5} />
        </button>
      </div>
      {value === 0 && (
        <p className="text-[11px] text-red-500 font-medium mt-1">Nema na stanju</p>
      )}
    </div>
  );
}
